import React from "react";

export default ({ pageName }) => {
  return (
    <>
      <div className="storefront-page-content-header">{pageName} </div>{" "}
    </>
  );
};
